module.exports = __webpack_public_path__ + "img/wagon.7b1dd961.svg";